// ======================================================================
// FILE: src/modules/wms/calendar/pages/CalendarListPage.js
// MODULE: Work Management System (WMS)
// FEATURE: Calendar Management
// PURPOSE:
//   Calendar Listing Screen
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
  useNavigate,
} from "react-router-dom";

import wmsCalendarService
from "../../services/wmsCalendarService";

export default function CalendarListPage() {

  const navigate = useNavigate();

  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [pagination, setPagination] =
    useState({});

  const [summary, setSummary] =
    useState({
      totalCalendars: 0,
      defaultCalendars: 0,
      totalShifts: 0,
      totalHolidays: 0,
    });

  const [filters, setFilters] =
    useState({
      q: "",
      calendar_type: "",
      page: 1,
      per_page: 20,
    });

  // ==========================================================
  // LOAD DATA
  // ==========================================================

  async function loadData() {

    try {

      setLoading(true);

      const result =
        await wmsCalendarService
          .listCalendars(filters);

      const items =
        result.items || [];

      setRows(items);

      setPagination(
        result.pagination || {}
      );

      // ------------------------------------------------------
      // KPI SUMMARY
      // ------------------------------------------------------

      let defaultCount = 0;

      items.forEach((row) => {

        if (row.is_default) {
          defaultCount += 1;
        }

      });

      setSummary({

        totalCalendars:
          result.pagination?.total
          || items.length,

        defaultCalendars:
          defaultCount,

        totalShifts: 0,

        totalHolidays: 0,
      });

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.message
        || "Failed to load calendars"
      );

    } finally {

      setLoading(false);
    }
  }

  useEffect(() => {

    loadData();

  }, [filters.page]);

  // ==========================================================
  // SEARCH
  // ==========================================================

  function handleSearch() {

    setFilters((prev) => ({
      ...prev,
      page: 1,
    }));

    loadData();
  }

  // ==========================================================
  // DELETE
  // ==========================================================

  async function handleDelete(row) {

    const ok = window.confirm(
      `Delete Calendar ${row.calendar_name}?`
    );

    if (!ok) return;

    try {

      await wmsCalendarService
        .deleteCalendar(row.id);

      await loadData();

    } catch (err) {

      alert(
        err?.response?.data?.message
        || "Delete failed"
      );
    }
  }

  // ==========================================================
  // UI
  // ==========================================================

  return (

    <div className="container-fluid">

      {/* ==================================================== */}
      {/* PAGE HEADER */}
      {/* ==================================================== */}

            <div
        className="card border-0 mb-4"
        style={{
            background:
            "linear-gradient(90deg,#0d6efd,#4f8cff)",
            borderRadius: "12px",
            color: "#fff",
        }}
        >

        <div className="card-body d-flex justify-content-between align-items-center">

            <div>

            <h2 className="mb-1">
                Calendar Management
            </h2>

            <div>
                Manage calendars, shifts,
                workdays and holidays
            </div>

            </div>

            <div>

            <button
                className="btn btn-light me-2"
                onClick={loadData}
            >
                <i className="fas fa-sync-alt me-2" />
                Refresh
            </button>

            <Link
                to="/wms/calendars/create"
                className="btn btn-outline-light"
            >
                <i className="fas fa-plus me-2" />
                Create Calendar
            </Link>

            </div>

        </div>

        </div>

      

      {/* ==================================================== */}
      {/* KPI CARDS */}
      {/* ==================================================== */}

       <div className="row mb-4">

  <div className="col-md-3">

        <div
        className="card shadow-sm h-100"
        style={{
            borderTop:
            "4px solid #0d6efd",
        }}
        >

        <div className="card-body d-flex justify-content-between">

            <div>

            <div className="text-muted">
                Total Calendars
            </div>

            <h2>
                {summary.totalCalendars}
            </h2>

            </div>

            <i
            className="fas fa-calendar-alt"
            style={{
                fontSize: 28,
                color: "#0d6efd",
            }}
            />

        </div>

        </div>

    </div>

    <div className="col-md-3">

        <div
        className="card shadow-sm h-100"
        style={{
            borderTop:
            "4px solid #28a745",
        }}
        >

        <div className="card-body d-flex justify-content-between">

            <div>

            <div className="text-muted">
                Default Calendars
            </div>

            <h2>
                {summary.defaultCalendars}
            </h2>

            </div>

            <i
            className="fas fa-check-circle"
            style={{
                fontSize: 28,
                color: "#28a745",
            }}
            />

        </div>

        </div>

    </div>

    <div className="col-md-3">

        <div
        className="card shadow-sm h-100"
        style={{
            borderTop:
            "4px solid #6f42c1",
        }}
        >

        <div className="card-body d-flex justify-content-between">

            <div>

            <div className="text-muted">
                Shift Configurations
            </div>

            <h2>
                {summary.totalShifts}
            </h2>

            </div>

            <i
            className="fas fa-users-cog"
            style={{
                fontSize: 28,
                color: "#6f42c1",
            }}
            />

        </div>

        </div>

    </div>

    <div className="col-md-3">

        <div
        className="card shadow-sm h-100"
        style={{
            borderTop:
            "4px solid #fd7e14",
        }}
        >

        <div className="card-body d-flex justify-content-between">

            <div>

            <div className="text-muted">
                Holidays Configured
            </div>

            <h2>
                {summary.totalHolidays}
            </h2>

            </div>

            <i
            className="fas fa-umbrella-beach"
            style={{
                fontSize: 28,
                color: "#fd7e14",
            }}
            />

        </div>

        </div>

    </div>

    </div> 
      
      {/* ==================================================== */}
      {/* SEARCH PANEL */}
      {/* ==================================================== */}

      <div
        className="card shadow-sm mb-4"
        style={{
            borderRadius: "12px",
        }}
        >

        <div className="card-body">

          <div className="row">

            <div className="col-md-4">

              <label>
                Search
              </label>

              <input
                className="form-control"
                value={filters.q}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    q: e.target.value,
                  })
                }
                placeholder="Code / Name"
              />

            </div>

            <div className="col-md-3">

              <label>
                Calendar Type
              </label>

              <select
                className="form-control"
                value={
                  filters.calendar_type
                }
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    calendar_type:
                      e.target.value,
                  })
                }
              >

                <option value="">
                  All
                </option>

                <option value="WORKING">
                  Working Calendar
                </option>

                <option value="BUSINESS">
                  Business Calendar
                </option>

                <option value="SHIFT">
                  Shift Calendar
                </option>

              </select>

            </div>

            <div
              className="col-md-2 d-flex align-items-end"
            >

              <button
                className="btn btn-primary"
                onClick={handleSearch}
              >
                Search
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* ==================================================== */}
      {/* GRID */}
      {/* ==================================================== */}

      <div
        className="card shadow-sm"
        style={{
            borderRadius: "12px",
        }}
        >

        <div className="card-body p-0">

          <table
            className="
                table
                table-hover
                table-striped
                align-middle
                mb-0
                "
          >

            <thead className="table-light">

              <tr>

                <th>
                  Calendar Code
                </th>

                <th>
                  Calendar Name
                </th>

                <th>
                  Calendar Type
                </th>

                <th>
                  Timezone
                </th>

                <th>
                  Default
                </th>

                <th>
                  Status
                </th>

                <th width="320">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {loading && (

                <tr>

                  <td
                    colSpan="7"
                    className="text-center"
                  >
                    Loading...
                  </td>

                </tr>

              )}

              {!loading &&
                rows.length === 0 && (

                <tr>

                  <td
                    colSpan="7"
                    className="text-center"
                  >
                    No Records Found
                  </td>

                </tr>

              )}

              {!loading &&
                rows.map((row) => (

                <tr key={row.id}>

                  <td>
                    {row.calendar_code}
                  </td>

                  <td>
                    {row.calendar_name}
                  </td>

                  <td>

                    <span className="badge bg-info">

                        {row.calendar_type}

                    </span>

                    </td>

                  <td>
                    {row.timezone}
                  </td>

                  <td>

                    <span
                        className={
                        row.is_default
                            ? "badge bg-primary"
                            : "badge bg-secondary"
                        }
                    >
                        {
                        row.is_default
                            ? "Yes"
                            : "No"
                        }
                    </span>

                    </td>

                  <td>

                    <span
                        className={
                        row.is_active
                            ? "badge bg-success"
                            : "badge bg-danger"
                        }
                    >
                        {
                        row.is_active
                            ? "Active"
                            : "Inactive"
                        }
                    </span>

                    </td>

                  <td>
                        <button
                            className="btn btn-sm btn-primary me-1"
                            onClick={() =>
                                navigate(
                                `/wms/calendars/${row.id}/edit`
                                )
                            }
                            >
                            <i className="fas fa-folder-open me-1" />
                            Open
                            </button>

                            <button
                            className="btn btn-sm btn-danger"
                            onClick={() =>
                                handleDelete(row)
                            }
                            >
                            <i className="fas fa-trash me-1" />
                            Delete
                            </button>
                    

                    

                    

                    

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}